import { FC, useContext } from "react";
import DataTable from "../../../../../shared/components/dataTable";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import Loader from "../../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../../shared/components/noPermissionBanner";
import SearchBox from "../../../../../layouts/SidebarLayout/Header/SearchBox";
import { TableViewContainer } from "../../../../../shared/components/tableViewContainer";
import { Qualification } from "../../../../../shared/interfaces/qualification";

const QualificationList: FC = () => {
  const navigate = useNavigate();
  const { payload, setPayload } = useContext(SidebarContext);

  const { loading, data, fetchData, error } = useQuery("/qualification", {
    params: {
      ...payload,
    },
  });

  const qualificationData = data as any;
  const navigateToDetails = () => {
    navigate("/master-datas/qualifications/create");
  };

  const qualificationDisplayColumns = ["name", "qualificationType", "enabled"];
  let qualificationList: Qualification[] = [];
  qualificationList = qualificationData?.items?.map((qualification: any) => {
    return {
      id: qualification.id,
      name: qualification?.name,
      qualificationType: qualification?.qualificationType,
      enabled: qualification?.enabled,
    };
  });

  const titleBarNode = <SearchBox />;
  const titleBar = {
    title: "Qualifications",
    headerTitle: "Qualifications",
    buttonTitle: "Create",
    titleBarNodes:
      (qualificationData?.totalItems || payload.search) && titleBarNode,
    onClick: navigateToDetails,
    disabled: qualificationData?.entityPermissions
      ? !qualificationData?.entityPermissions?.includes("Qualification-Create")
      : false,
    subHeading: "",
    rowCount: qualificationData?.totalItems,
  };

  return (
    <TableViewContainer titleBar={titleBar}>
      {loading && <Loader />}
      {(error as any)?.statusCode === 403 && <NoPermissionContent />}
      {!loading && !error && (
        <DataTable
          entityName="Qualification"
          data={qualificationList}
          displayColumns={qualificationDisplayColumns}
          linkColumn="name"
          linkUrl="/master-datas/qualifications"
          pagination={{ take: payload.take, skip: payload.skip }}
          setPagination={setPayload}
          totalItems={qualificationData?.totalItems}
          deleteApiUrl="/qualification"
          refetchFunction={fetchData}
          disabled={
            qualificationData?.entityPermissions
              ? !qualificationData?.entityPermissions?.includes(
                  "Qualification-Delete"
                )
              : false
          }
        />
      )}
    </TableViewContainer>
  );
};

export default QualificationList;
